<template>
  <div
    class=main--text>
    <v-lp-tool-bar />
    <v-img
      :src="familyAndComputer"
      gradient="to top right, rgba(0,0,0,.33), rgba(0,0,0,.7)"
      :height="500">
      <v-container
        fluid
        fill-height
        class=main--text>
        <v-row
          justify=end
          align=center>
          <v-col
            cols=12
            md=6>
            <h1
              :class="headingStyle">無料体験授業</h1>
          </v-col>
        </v-row>
      </v-container>
    </v-img>
    <v-section-bar
      message="無料体験授業とは" />
      <v-container
        fluid>
        <v-row
          justify=center>
          <v-col
            cols=12
            md=6>
            <v-card>
              <v-container
                fluid>
                <v-row>
                  <v-col>
                    <h2>体験の目的</h2>
                  </v-col>
                </v-row>
                <v-row>

                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
        <v-row
          justify=center>
          <v-col
            cols=12
            md=6>
            <v-card>
              <v-container
                fluid>
                <v-row>
                  <v-col>
                    <h2>体験の内容</h2>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    Prosenseのオンラインエディタを使って、実際にプログラミングの授業を受けていただきます。
                    実際の開発現場でも使われている言語に触れながら、「プログラミングとは何か」、「どんなことができるのか」を学びます。
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
        <v-row
          justify=center>
          <v-col
            cols=12
            md=6>
            <v-card>
              <v-container
                fluid>
                <v-row>
                  <v-col>
                    <h2>体験できるプログラミング言語</h2>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols=12
                    md=2>
                    <v-icon
                      size=100
                      color=blue>mdi-language-python</v-icon>
                  </v-col>
                  <v-col
                    cols=12
                    md=10>
                    <v-container
                      class="no--vertical--paddings"
                      fluid>
                      <v-row
                        justify=start>
                        <v-col
                          class="no--vertical--paddings">
                          <h3>Python</h3>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          世界中で人気が急上昇しているプログラミング言語です。
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                  <v-col
                    cols=12
                    md=2>
                    <v-icon
                      size=100
                      color=blue>mdi-language-javascript</v-icon>
                  </v-col>
                  <v-col
                    cols=12
                    md=10>
                    <v-container
                      class="no--vertical--paddings">
                      <v-row
                        justify=start>
                        <v-col
                          class="no--vertical--paddings">
                          <h3>JavaScript</h3>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    <v-section-bar
      message="受講の流れ"/>
      <v-container
        fluid>
        <v-row
          justify=center>
          <v-col
            cols=12
            md=6>
            <v-card>
              <v-container
                fluid>
                <v-row>
                  <v-col>
                    <h2>公式LINEアカウントを友だち登録</h2>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
        <v-row
          justify=center>
          <v-col
            cols=12
            md=6>
            <v-card>
              <v-container
                fluid>
                <v-row>
                  <v-col>
                    <h2>トーク画面からお申し込み</h2>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
        <v-row
          justify=center>
          <v-col
            cols=12
            md=6>
            <v-card>
              <v-container
                fluid>
                <v-row>
                  <v-col>
                    <h2>担当講師と日程調整・ヒアリング</h2>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
        <v-row
          justify=center>
          <v-col
            cols=12
            md=6>
            <v-card>
              <v-container
                fluid>
                <v-row>
                  <v-col>
                    <h2>体験授業を受講</h2>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    <v-section-bar
      message="必要な準備"/>
      <v-container
        fluid>
        <v-row
          justify=center>
          <v-col
            cols=12
            md=6>
            <v-card>
              <v-container
                fluid>
                <v-row>
                  <v-col>
                    <v-icon
                      size="100px"
                      color="blue">
                      mdi-laptop-chromebook
                    </v-icon>
                  </v-col>
                </v-row>
                <v-divider/>
                <v-row>
                  <v-col>
                    <v-icon
                      size="100px"
                      color="blue">
                      mdi-google-chrome
                    </v-icon>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    <v-section-bar
      message="よくあるご質問"/>
      <v-container
        fluid>
        <v-row
          justify=center>
          <v-col
            cols=12
            md=6>
            <v-card>
              <v-container
                fluid>
                <dl
                  class="question-and-answer">
                  <dt>Q何歳から体験受講できますか？パソコンに不慣れでも大丈夫？</dt>
                  <dd>

                  </dd>
                </dl>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
        <v-row
          justify=center>
          <v-col
            cols=12
            md=6>
            <v-card>
              <v-container
                fluid>
                <dl
                  class="question--and--answer">
                  <dt>Q通話用のアプリやプログラミング言語をインストールする必要はありますか？</dt>
                  <dd>

                  </dd>
                </dl>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
        <v-row
          justify=center>
          <v-col
            cols=12
            md=6>
            <v-card>
              <v-container
                fluid>
                <dl
                  class="question--and--answer">
                  <dt>Qスマホ・タブレットからの受講は可能ですか？</dt>
                  <dd>

                  </dd>
                </dl>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    <v-lp-footer/>
  </div>
</template>

<script>
import FamilyAndComputer from '@/assets/img/family_and_computer.jpg'
import VLpToolBar from '@/components/organisms/lp/VLpToolBar.vue'
import VSectionBar from '@/components/molecules/VSectionBar.vue'
import VLpFooter from '@/components/organisms/lp/VLpFooter.vue'

export default {
  components: {
    VLpToolBar,
    VSectionBar,
    VLpFooter
  },
  data () {
    return {
      familyAndComputer: FamilyAndComputer
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
    headingStyle () {
      return (this.isMobile) ? 'heading-text-mobile' : 'heading-text'
    }
  }
}
</script>

<style scoped>
.heading-text {
  text-shadow: 0 2px 4px rgba(41,48,59,.55);
  font-weight: 600;
  color: white;
  font-size:5.0rem;
  letter-spacing:5px;
}

.heading-text-mobile {
  text-shadow: 0 2px 4px rgba(41,48,59,.55);
  font-weight: 600;
  color: white;
  font-size:3.5rem;
  letter-spacing:3px;
}

.no--vertical--paddings {
  padding: 0px 12px;
}


.question-and-answer {
  margin: 10px;
  line-height: 1.6rem;
  overflow: hidden;
  _zoom: 1;
}

.question-and-answer dd,
.question-and-answer dt {
  text-indent: -2.0rem;
  padding: 0 20px 0px 50px;
}

.question-and-answer dt {
  margin: 20px 20px 0 0;
  font-size: 1.3rem;
  font-weight: bold
}

.question-and-answer dd::first-letter,
.question-and-answer dt::first-letter {
  font-size: 1.6rem;
  font-weight: bold;
  margin-right: 5px;
  padding: 5px;
}

.question-and-answer dd {
  margin: 20px 0 -1px 0;
  padding-bottom: 15px;
  border-bottom: 1px #000 dotted;
  font-size: 1.0rem;
}

.question-and-answer dt::first-letter {
  color: #0f78e1;
}
.question-and-answer dd::first-letter {
  color: #ff6767;
}

.question-and-answer ul {
  margin: 10px 0px 10px 30px;
  list-style: none;
}
</style>
